__turbopack_context__.v({
  "wrapper": "AuthorInfo-module-scss-module__n0FiTq__wrapper",
});
